/*
 * $Id:: ConfirmStatusChangeDialog.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    cancelButton: {
        textTransform: 'uppercase',
        backgroundColor: theme.palette.text.mainGreen,
        borderColor: theme.palette.text.mainGreen,
        minWidth: '66px',
        '&:hover': {
            backgroundColor: theme.palette.text.mainGreen,
            borderColor: theme.palette.text.mainGreen,
        },
        '&:active': {
            backgroundColor: theme.palette.text.mainGreen,
            borderColor: theme.palette.text.mainGreen,
        },
    },
    confirmButton: {
        textTransform: 'uppercase',
    },
}));

const ConfirmStatusChangeDialog = ({ childAccount, open, onAccept, onCancel, action }) => {
    const classes = useStyles();
    const { firstName, lastName, email } = childAccount;
    return (
        <Dialog open={open} onClose={onCancel} aria-labelledby="confirm-status-update-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{action && t(`${action}.account.title`)}</DialogTitle>
            <DialogContent>
                <DialogContentText>{action && t(`child.account.${action}`, { firstName, lastName, email })}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className={classes.confirmButton} variant="outlined" onClick={onAccept}>
                    {t('button.yes.text')}
                </Button>
                <Button className={classes.cancelButton} variant="contained" onClick={onCancel}>
                    {t('cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmStatusChangeDialog;
